/** Small "(i)" affordance carrying a field explanation via native title/aria-label tooltip. */
export function InfoTip({ text }: { text: string }) {
  return (
    <button type="button" className="info-tip" title={text} aria-label={text}>
      i
    </button>
  );
}
